import React, { Component } from 'react';
import '../App.css';
import '../styles/lead-gen.css';
import NumberFormat from 'react-number-format';

class LeadForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: null,
      phone: null,
      email: null,
      company: null
    }
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  render() {
    
    return (
      <section id="lead-form-section">
            <form action="https://formspree.io/mayqlvpe" method="post">
                <h2>Let's get in touch!</h2>
                <div className="input-wrapper">
                  <p>First Name</p>
                  <input required type="text" id="first_name" name="First Name" />
                </div>
                <div className="input-wrapper">
                  <p>Last Name</p>
                  <input required type="text" id="last_name" name="Last Name" />
                </div>
                <div className="input-wrapper">
                  <p>Phone</p>
                  <NumberFormat required type="tel" name="Phone" placeholder="(   ) ___-____" format="(###) ###-####" mask="_"></NumberFormat>
                </div>
                <div className="input-wrapper">
                  <p>Email</p>
                  <input required type="text" name="Email" />          
                </div>
                <div className="input-wrapper">
                  <p>Company</p>
                  <input required type="text" id="company" name="Company" />
                </div>
                <div className="input-wrapper">
                  <p>State</p>
                  <input required type="text" id="state" name="State" />
                </div>
                <div className="input-wrapper">
                  <p>Zip</p>
                  <input type="text" id="zip" name="Zip" />
                </div>
                <div className="input-wrapper">
                <p>Estimated Number of Employees</p>
                  <select id="estimated_number_of_employees" name="Estimated Number of Employees" required>
                    <option value="">Choose One</option>
                    <option value="1-50">1-50</option>
                    <option value="51-100">51-100</option>
                    <option value="101-500">101-500</option>
                    <option value="501-1000">501-1000</option>
                    <option value="1001+">1001+</option>
                  </select>
                </div>
                <div className="input-wrapper">
                  <p>Referring Partner (if applicable)</p>
                  <input type="text" id="referring-partner" name="Referring Partner" />
                </div>
                <div className="input-wrapper">
                  <button type="submit">Submit</button>
                </div>
            </form>
      </section>
    );
  }
}

export default LeadForm;
